/*!
 * IPC Quick Cards v1.0 - Indescribable Peace Creations
 * Adds "Quick Buy" + a -/+ quantity pill to product cards (Horizon/Flora theme),
 * and a "Choose your options" panel on the cart page for multi-variant items.
 * Vanilla JS (ES2018), no dependencies. Safe to remove: delete this file + its <script> tag.
 */
(function () {
  'use strict';
  if (window.IPCQuickCards && window.IPCQuickCards.version) return;

  /* ------------------------------------------------------------------ config */
  var CFG = Object.assign({
    keepThemeQuickAdd: false,   // true = keep the theme's round quick-add button (stacked above our pill)
    drawerNote: true,           // show a "choose options" note inside the cart drawer
    storageKey: 'ipc-qc-pending-v1',
    cacheKey: 'ipc-qc-prod-v1:',
    cacheTtl: 10 * 60 * 1000,   // product JSON cache (sessionStorage), ms
    pendingMaxAgeDays: 30,
    maxQty: 99
  }, window.IPCQuickCardsConfig || {});

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var URLS = {
    cart: ROOT + 'cart',
    cartJs: ROOT + 'cart.js',
    add: ROOT + 'cart/add.js',
    change: ROOT + 'cart/change.js',
    product: function (h) { return ROOT + 'products/' + encodeURIComponent(h) + '.js'; },
    productPage: function (h) { return ROOT + 'products/' + encodeURIComponent(h); }
  };
  var SOURCE = 'ipc-quick-cards';

  /* ----------------------------------------------------------------- helpers */
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'text') n.textContent = v;
      else if (k === 'class') n.className = v;
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    src = String(src).replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function clampQty(n) { n = parseInt(n, 10); if (isNaN(n) || n < 0) n = 0; return Math.min(n, CFG.maxQty); }
  function isCartPage() {
    var t = window.Theme && window.Theme.template && window.Theme.template.name;
    return t === 'cart' || /\/cart\/?$/.test(location.pathname);
  }
  function friendly(err) {
    var d = (err && err.message) || '';
    if (/sold out/i.test(d)) return 'Sorry, this item is sold out.';
    if (err && err.status === 422 && d) return d;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'You appear to be offline. Please try again.';
    return 'Could not update your cart. Please try again.';
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && Number(j.status) >= 400)) {
          var e = new Error((j && (j.description || j.message)) || 'Request failed');
          e.status = r.status; throw e;
        }
        return j;
      });
    });
  }
  // Serialize every cart request so rapid taps never race each other.
  var queue = Promise.resolve();
  function enqueue(fn) { var p = queue.then(fn, fn); queue = p.catch(function () {}); return p; }

  /* ------------------------------------------------------ pending (localStorage) */
  var memPending = [];
  function readPending() {
    var items;
    try { var raw = localStorage.getItem(CFG.storageKey); items = raw ? (JSON.parse(raw).items || []) : []; }
    catch (e) { items = memPending; }
    var maxAge = CFG.pendingMaxAgeDays * 864e5, now = Date.now();
    return items.filter(function (it) { return it && it.handle && it.qty > 0 && (!it.t || now - it.t < maxAge); });
  }
  function writePending(items) {
    memPending = items;
    try { localStorage.setItem(CFG.storageKey, JSON.stringify({ v: 1, items: items })); } catch (e) {}
    onPendingChanged();
  }
  function getPending(handle) {
    var items = readPending();
    for (var i = 0; i < items.length; i++) if (items[i].handle === handle) return items[i];
    return null;
  }
  function setPendingQty(info, qty) {
    qty = clampQty(qty);
    var items = readPending(), found = null;
    items.forEach(function (it) { if (it.handle === info.handle) found = it; });
    if (qty <= 0) items = items.filter(function (it) { return it.handle !== info.handle; });
    else if (found) { found.qty = qty; found.t = Date.now(); }
    else items.push({ handle: info.handle, productId: info.productId || null, title: info.title || '', image: info.image || '', qty: qty, t: Date.now() });
    writePending(items);
  }
  function removePending(handle) { writePending(readPending().filter(function (it) { return it.handle !== handle; })); }

  /* -------------------------------------------------------------------- cart */
  var cart = null;
  function setCart(c) { if (c && c.items) cart = c; return cart; }
  function fetchCartRaw() {
    return fetch(URLS.cartJs + '?_=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(setCart);
  }
  function refreshCart() { return fetchCartRaw().then(function (c) { renderAllCards(); return c; }).catch(function () {}); }
  function cartLines(variantId) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return String(i.variant_id) === String(variantId); });
  }
  function cartQty(variantId) { return cartLines(variantId).reduce(function (s, i) { return s + i.quantity; }, 0); }
  function notifyTheme(c) {
    if (!c) return;
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
        resource: c, sourceId: SOURCE, data: { itemCount: c.item_count, source: SOURCE }
      } }));
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- products */
  var prodMem = {};
  var active = 0, waiting = [];
  function limit(fn) {
    return new Promise(function (res, rej) {
      var run = function () { active++; fn().then(res, rej).then(function () { active--; if (waiting.length) waiting.shift()(); }); };
      if (active < 4) run(); else waiting.push(run);
    });
  }
  function slim(p) {
    var variants = (p.variants || []).map(function (v) {
      var opts = v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      return { id: v.id, title: v.title, options: opts, available: !!v.available, price: v.price,
               image: v.featured_image ? (v.featured_image.src || v.featured_image) : null };
    });
    var options = (p.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var vals = [];
        variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values || [] };
    });
    return { id: p.id, handle: p.handle, title: p.title, available: !!p.available, url: p.url,
             image: p.featured_image || (p.images && p.images[0]) || '', price: p.price, priceVaries: !!p.price_varies,
             requiresSellingPlan: !!p.requires_selling_plan, options: options, variants: variants };
  }
  function loadProduct(handle, fresh) {
    if (!fresh && prodMem[handle]) return prodMem[handle];
    if (!fresh) {
      try {
        var c = JSON.parse(sessionStorage.getItem(CFG.cacheKey + handle) || 'null');
        if (c && Date.now() - c.t < CFG.cacheTtl) return (prodMem[handle] = Promise.resolve(c.p));
      } catch (e) {}
    }
    var p = limit(function () {
      return fetch(URLS.product(handle) + (fresh ? '?_=' + Date.now() : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Product ' + r.status); return r.json(); });
    }).then(function (raw) {
      var s = slim(raw);
      try { sessionStorage.setItem(CFG.cacheKey + handle, JSON.stringify({ t: Date.now(), p: s })); } catch (e) {}
      return s;
    });
    prodMem[handle] = p;
    p.catch(function () { if (prodMem[handle] === p) delete prodMem[handle]; });
    return p;
  }
  function isSingle(p) { return p.variants.length === 1; }

  /* ------------------------------------------------------------------- cards */
  var recs = new Set();
  var live = null; // shared polite live region
  function announce(msg) {
    if (!live) {
      live = el('div', { class: 'ipc-qc-sr', role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' });
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var rec = en.target.__ipcQc;
      if (rec) ensureProduct(rec).catch(function () {});
    });
  }, { rootMargin: '300px 0px' }) : null;

  function cardTitle(card) {
    var qa = card.querySelector('[data-product-title]');
    if (qa && qa.getAttribute('data-product-title')) return qa.getAttribute('data-product-title').trim();
    var a = card.querySelector('.card-gallery a[aria-label]');
    if (a) return a.getAttribute('aria-label').trim();
    var vh = card.querySelector('.product-card__link .visually-hidden');
    if (vh) return vh.textContent.trim();
    return '';
  }
  function cardImage(card) {
    var img = card.querySelector('slideshow-slide[aria-hidden="false"] img') || card.querySelector('.card-gallery img');
    return img ? (img.currentSrc || img.src || '') : '';
  }

  function buildControls(rec) {
    var t = rec.title || 'this item';
    var buy = el('button', { type: 'button', class: 'ipc-qc__buy', 'data-ipc-act': 'buy', 'aria-label': 'Quick buy ' + t, text: 'Quick Buy' });
    var minus = el('button', { type: 'button', class: 'ipc-qc__btn ipc-qc__minus', 'data-ipc-act': 'minus', 'aria-label': 'Remove ' + t },
      [el('span', { 'aria-hidden': 'true', text: '\u2212' })]);
    var qty = el('span', { class: 'ipc-qc__qty', 'aria-hidden': 'true', hidden: true, text: '0' });
    var plus = el('button', { type: 'button', class: 'ipc-qc__btn ipc-qc__plus', 'data-ipc-act': 'plus', 'aria-label': 'Add ' + t },
      [el('span', { 'aria-hidden': 'true', text: '+' })]);
    var pill = el('div', { class: 'ipc-qc__pill', role: 'group', 'aria-label': 'Quantity: ' + t }, [minus, qty, plus]);
    var tag = el('span', { class: 'ipc-qc__soldout', hidden: true, text: 'Sold out' });
    var msg = el('span', { class: 'ipc-qc__msg', hidden: true });
    var root = el('div', { class: 'ipc-qc', 'data-ipc-qc': '' }, [buy, pill, msg, tag]);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('button') : null;
      e.stopPropagation();
      if (!btn || !root.contains(btn)) { if (e.target.closest && e.target.closest('.ipc-qc__pill')) e.preventDefault(); return; }
      e.preventDefault();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      onAction(rec, btn.getAttribute('data-ipc-act'));
    });
    rec.root = root; rec.buy = buy; rec.pill = pill; rec.minus = minus; rec.plus = plus; rec.qtyEl = qty; rec.tag = tag; rec.msg = msg;
  }

  function enhance(card) {
    if (card.closest('.quick-add-modal, predictive-search-component, .ipc-qc-panel')) return;
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    var rec = card.__ipcQc;
    if (rec) {
      if (rec.root.parentNode !== gallery) {
        gallery.appendChild(rec.root); rec.gallery = gallery; gallery.__ipcQcRec = rec;
      }
      if (!card.classList.contains('ipc-qc-on')) card.classList.add('ipc-qc-on');
      recs.add(rec);
      return;
    }
    var link = card.querySelector('a[href*="/products/"]');
    var handle = handleFromHref(link && link.getAttribute('href'));
    if (!handle) return;
    rec = { card: card, gallery: gallery, handle: handle, productId: card.getAttribute('data-product-id'),
            title: cardTitle(card), product: null, ops: 0, optimistic: null };
    buildControls(rec);
    gallery.appendChild(rec.root);
    gallery.__ipcQcRec = rec;
    card.classList.add('ipc-qc-on');
    card.__ipcQc = rec;
    recs.add(rec);
    if (io) io.observe(card); else ensureProduct(rec).catch(function () {});
    renderCard(rec);
  }

  function ensureProduct(rec) {
    if (rec.product) return Promise.resolve(rec.product);
    return loadProduct(rec.handle).then(function (p) {
      rec.product = p;
      if (!rec.title) { rec.title = p.title; relabel(rec); }
      renderAllCards(rec.handle);
      return p;
    });
  }
  function relabel(rec) {
    var t = rec.title || 'this item';
    rec.buy.setAttribute('aria-label', 'Quick buy ' + t);
    rec.minus.setAttribute('aria-label', 'Remove ' + t);
    rec.plus.setAttribute('aria-label', 'Add ' + t);
  }
  function realQty(rec) {
    var p = rec.product;
    if (p && isSingle(p)) return cartQty(p.variants[0].id);
    var pe = getPending(rec.handle);
    return pe ? pe.qty : 0;
  }
  function shownQty(rec) { return rec.optimistic != null ? rec.optimistic : realQty(rec); }

  function renderCard(rec) {
    if (!rec.root) return;
    var p = rec.product, qty = shownQty(rec), soldOut = !!(p && !p.available);
    rec.qtyEl.textContent = String(qty);
    rec.qtyEl.hidden = qty <= 0;
    rec.minus.setAttribute('aria-disabled', qty <= 0 ? 'true' : 'false');
    rec.plus.disabled = soldOut;
    rec.buy.disabled = soldOut;
    rec.tag.hidden = !soldOut;
    rec.root.classList.toggle('ipc-qc--has-qty', qty > 0);
    rec.root.classList.toggle('ipc-qc--soldout', soldOut);
    if (p) rec.root.setAttribute('data-ipc-mode', isSingle(p) ? 'single' : 'multi');
  }
  function renderAllCards(handle) {
    recs.forEach(function (rec) {
      if (!rec.card.isConnected) { recs.delete(rec); return; }
      if (!handle || rec.handle === handle) renderCard(rec);
    });
  }
  var msgTimer = new WeakMap();
  function showMsg(rec, text) {
    rec.msg.textContent = text;
    rec.msg.hidden = false;
    clearTimeout(msgTimer.get(rec));
    msgTimer.set(rec, setTimeout(function () { rec.msg.hidden = true; }, 3500));
    announce(text);
  }

  function onAction(rec, act) {
    var wasLoaded = !!rec.product;
    if (!wasLoaded) rec.root.classList.add('ipc-qc--busy');
    ensureProduct(rec).then(function (p) {
      rec.root.classList.remove('ipc-qc--busy');
      if (p.requiresSellingPlan) { location.href = URLS.productPage(rec.handle); return; }
      if (isSingle(p)) singleAction(rec, p, act); else multiAction(rec, p, act);
    }, function () {
      rec.root.classList.remove('ipc-qc--busy');
      location.href = URLS.productPage(rec.handle); // safe fallback: let the product page handle it
    });
  }

  function singleOp(rec, v, delta) {
    rec.ops++;
    rec.optimistic = Math.max(0, shownQty(rec) + delta);
    renderCard(rec);
    var failed = null;
    return enqueue(function () {
      if (delta > 0) {
        return postJSON(URLS.add, { items: [{ id: v.id, quantity: 1 }] }).then(fetchCartRaw);
      }
      var lines = cartLines(v.id), line = lines[lines.length - 1];
      if (!line) return fetchCartRaw();
      return postJSON(URLS.change, { id: line.key, quantity: line.quantity - 1 }).then(setCart);
    }).catch(function (err) {
      failed = err;
      return fetchCartRaw().catch(function () {});
    }).then(function () {
      rec.ops--;
      if (failed) showMsg(rec, friendly(failed));
      if (!rec.ops) {
        rec.optimistic = null;
        renderAllCards(rec.handle);
        notifyTheme(cart);
        if (!failed) {
          var q = cartQty(v.id);
          announce(q > 0 ? rec.title + ': ' + q + ' in cart' : rec.title + ' removed from cart');
        }
      }
      if (failed) throw failed;
    });
  }

  function singleAction(rec, p, act) {
    var v = p.variants[0];
    if (act === 'plus') {
      if (!p.available || !v.available) return;
      if (shownQty(rec) >= CFG.maxQty) return;
      singleOp(rec, v, 1).catch(function () {});
    } else if (act === 'minus') {
      if (shownQty(rec) <= 0) return;
      singleOp(rec, v, -1).catch(function () {});
    } else if (act === 'buy') {
      if (!p.available || !v.available) return;
      rec.buy.setAttribute('aria-busy', 'true');
      rec.root.classList.add('ipc-qc--busy');
      enqueue(function () { return null; }).then(function () {
        // Wait for any queued +/- and make sure the cart reflects them.
        return fetchCartRaw();
      }).then(function () {
        if (cartQty(v.id) >= 1) return null;
        return singleOp(rec, v, 1);
      }).then(function () {
        location.href = URLS.cart;
      }).catch(function () {
        rec.buy.removeAttribute('aria-busy');
        rec.root.classList.remove('ipc-qc--busy');
      });
    }
  }

  function multiAction(rec, p, act) {
    var info = { handle: rec.handle, productId: p.id, title: rec.title || p.title, image: imgUrl(p.image || cardImage(rec.card), 200) };
    var cur = realQty(rec);
    if (act === 'plus') {
      if (!p.available || cur >= CFG.maxQty) return;
      setPendingQty(info, cur + 1);
      showMsg(rec, cur === 0 ? 'Saved \u2013 choose options in cart' : (cur + 1) + ' saved \u2013 choose options in cart');
    } else if (act === 'minus') {
      if (cur <= 0) return;
      setPendingQty(info, cur - 1);
      announce(cur - 1 > 0 ? rec.title + ': ' + (cur - 1) + ' saved' : rec.title + ' removed');
    } else if (act === 'buy') {
      if (!p.available) return;
      setPendingQty(info, Math.max(1, cur));
      if (isCartPage()) { syncPanel(); if (panel) panel.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      else location.href = URLS.cart;
    }
  }

  function onPendingChanged() {
    renderAllCards();
    if (isCartPage()) syncPanel();
    syncDrawerNote();
  }

  /* --------------------------------------------------- cart page: options panel */
  var panel = null;
  function buildPanel() {
    var list = el('ul', { class: 'ipc-qc-panel__list', role: 'list' });
    var status = el('p', { class: 'ipc-qc-panel__status', role: 'status', 'aria-live': 'polite' });
    var saveAll = el('button', { type: 'button', class: 'ipc-qc-btn ipc-qc-btn--primary ipc-qc-panel__saveall', text: 'Save all' });
    var root = el('section', { class: 'ipc-qc-panel', 'aria-labelledby': 'ipc-qc-panel-title', 'data-ipc-qc': '' }, [
      el('div', { class: 'ipc-qc-panel__inner' }, [
        el('h2', { id: 'ipc-qc-panel-title', class: 'ipc-qc-panel__title', text: 'Choose your options' }),
        el('p', { class: 'ipc-qc-panel__intro', text: 'Pick size, color, or style for each item before checkout.' }),
        list,
        el('div', { class: 'ipc-qc-panel__footer' }, [status, saveAll])
      ])
    ]);
    saveAll.addEventListener('click', function () { saveAllRows(); });
    return { root: root, list: list, status: status, saveAll: saveAll, rows: {} };
  }
  function placePanel() {
    if (panel.root.isConnected) return;
    // Insert OUTSIDE the theme's cart section so the theme's morphing never wipes it.
    var ci = document.querySelector('cart-items-component:not([data-drawer])');
    var sec = ci && (ci.closest('.shopify-section') || ci);
    if (sec && sec.parentNode) { sec.parentNode.insertBefore(panel.root, sec); return; }
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    main.insertBefore(panel.root, main.firstChild);
  }
  function syncPanel() {
    if (!isCartPage()) return;
    var items = readPending();
    if (!items.length) {
      if (panel) { panel.root.remove(); panel = null; }
      return;
    }
    if (!panel) panel = buildPanel();
    placePanel();
    var handles = items.map(function (i) { return i.handle; });
    items.forEach(function (it) {
      var row = panel.rows[it.handle];
      if (!row) addRow(it);
      else if (document.activeElement !== row.qtyInput) row.qtyInput.value = String(it.qty);
    });
    Object.keys(panel.rows).forEach(function (h) {
      if (handles.indexOf(h) < 0) { panel.rows[h].el.remove(); delete panel.rows[h]; }
    });
  }

  var rowSeq = 0;
  function addRow(it) {
    var uid = 'ipc-qc-r' + (++rowSeq);
    var row = { handle: it.handle, uid: uid, selects: [], product: null };
    var img = it.image ? el('img', { class: 'ipc-qc-row__img', src: imgUrl(it.image, 160), alt: '', width: '80', height: '80', loading: 'lazy' })
                       : el('span', { class: 'ipc-qc-row__img ipc-qc-row__img--blank', 'aria-hidden': 'true' });
    row.titleEl = el('a', { class: 'ipc-qc-row__title', href: URLS.productPage(it.handle), id: uid + '-t', text: it.title || it.handle });
    row.priceEl = el('p', { class: 'ipc-qc-row__price' });
    row.optsEl = el('div', { class: 'ipc-qc-row__opts' }, [el('p', { class: 'ipc-qc-row__loading', text: 'Loading options\u2026' })]);
    row.qtyInput = el('input', { class: 'ipc-qc-row__qty', id: uid + '-q', type: 'number', inputmode: 'numeric', min: '1', max: String(CFG.maxQty), step: '1', value: String(it.qty) });
    var qtyWrap = el('div', { class: 'ipc-qc-field ipc-qc-field--qty' }, [el('label', { for: uid + '-q', text: 'Qty' }), row.qtyInput]);
    row.msgEl = el('p', { class: 'ipc-qc-row__msg', role: 'alert', hidden: true });
    row.addBtn = el('button', { type: 'button', class: 'ipc-qc-btn ipc-qc-btn--primary ipc-qc-row__add', 'aria-describedby': uid + '-t', text: 'Add to cart' });
    row.removeBtn = el('button', { type: 'button', class: 'ipc-qc-link ipc-qc-row__remove', 'aria-label': 'Remove ' + (it.title || 'item') + ' from this list', text: 'Remove' });
    row.el = el('li', { class: 'ipc-qc-row', 'data-handle': it.handle }, [
      img,
      el('div', { class: 'ipc-qc-row__main' }, [row.titleEl, row.priceEl,
        el('div', { class: 'ipc-qc-row__fields' }, [row.optsEl, qtyWrap]), row.msgEl]),
      el('div', { class: 'ipc-qc-row__actions' }, [row.addBtn, row.removeBtn])
    ]);
    row.qtyInput.addEventListener('change', function () {
      var q = clampQty(row.qtyInput.value); if (q < 1) q = 1;
      row.qtyInput.value = String(q);
      var pe = getPending(row.handle);
      if (pe && pe.qty !== q) setPendingQty(pe, q);
      updateRowState(row);
    });
    row.addBtn.addEventListener('click', function () {
      confirmRow(row).then(function (ok) { if (ok) afterAdds(1, 0); });
    });
    row.removeBtn.addEventListener('click', function () {
      removePending(row.handle);
      announce((it.title || 'Item') + ' removed from the list');
      if (panel) { var first = panel.root.querySelector('.ipc-qc-row select, .ipc-qc-row__qty'); if (first) first.focus(); }
    });
    panel.rows[it.handle] = row;
    panel.list.appendChild(row.el);

    loadProduct(it.handle, true).then(function (p) {
      row.product = p;
      row.titleEl.textContent = it.title || p.title;
      if (!it.image && p.image && img.tagName !== 'IMG') {
        var real = el('img', { class: 'ipc-qc-row__img', src: imgUrl(p.image, 160), alt: '', width: '80', height: '80', loading: 'lazy' });
        img.parentNode.replaceChild(real, img); img = real;
      }
      buildSelectors(row);
    }, function () {
      row.optsEl.innerHTML = '';
      showRowMsg(row, 'We could not load the options for this item. Please remove it and add it from the product page.');
      row.addBtn.disabled = true;
    });
  }

  function buildSelectors(row) {
    var p = row.product;
    row.optsEl.innerHTML = '';
    row.selects = [];
    row.fixed = [];
    if (!p.available) {
      showRowMsg(row, 'Sorry, this item is sold out. Please remove it.');
      row.addBtn.disabled = true;
    }
    if (p.variants.length > 1) {
      p.options.forEach(function (o, i) {
        if (o.values.length <= 1) { row.fixed[i] = o.values[0]; return; }
        var id = row.uid + '-o' + i;
        var sel = el('select', { id: id, class: 'ipc-qc-row__select', 'data-idx': String(i) },
          [el('option', { value: '', text: 'Choose ' + o.name.toLowerCase() })].concat(o.values.map(function (v) { return el('option', { value: v, text: v }); })));
        sel.addEventListener('change', function () { onSelectChange(row, i); });
        row.selects.push({ idx: i, el: sel, name: o.name });
        row.optsEl.appendChild(el('div', { class: 'ipc-qc-field' }, [el('label', { for: id, text: o.name }), sel]));
      });
    }
    refreshOptions(row);
    updateRowState(row);
  }
  function selection(row) {
    var p = row.product, s = [];
    p.options.forEach(function (o, i) { s[i] = row.fixed[i] != null ? row.fixed[i] : null; });
    row.selects.forEach(function (x) { s[x.idx] = x.el.value || null; });
    return s;
  }
  function matches(v, sel) {
    for (var i = 0; i < sel.length; i++) if (sel[i] != null && v.options[i] !== sel[i]) return false;
    return true;
  }
  // Availability of each value is evaluated against the selections of the options BEFORE it
  // (like Shopify's own pickers), so the customer can never get "locked in".
  function refreshOptions(row) {
    var p = row.product, sel = selection(row);
    row.selects.forEach(function (x) {
      var prefix = sel.map(function (v, j) { return j < x.idx ? v : (row.fixed[j] != null ? row.fixed[j] : null); });
      Array.prototype.forEach.call(x.el.options, function (opt) {
        if (!opt.value) return;
        var test = prefix.slice(); test[x.idx] = opt.value;
        var m = p.variants.filter(function (v) { return matches(v, test); });
        var avail = m.some(function (v) { return v.available; });
        opt.disabled = !avail;
        opt.textContent = opt.value + (avail ? '' : (m.length ? ' \u2013 sold out' : ' \u2013 unavailable'));
      });
    });
  }
  function onSelectChange(row, changedIdx) {
    hideRowMsg(row);
    refreshOptions(row);
    var reset = [];
    row.selects.forEach(function (x) {
      var o = x.el.options[x.el.selectedIndex];
      if (x.el.value && o && o.disabled) { reset.push(x.name + ' (' + x.el.value + ')'); x.el.value = ''; refreshOptions(row); }
    });
    if (reset.length) showRowMsg(row, 'That combination is not available. Please choose ' + reset.join(', ') + ' again.', true);
    updateRowState(row);
  }
  function resolveRow(row) {
    var p = row.product;
    if (!p) return { error: 'Options are still loading. Please wait a moment.' };
    if (!p.available) return { error: 'Sorry, this item is sold out.' };
    var qty = clampQty(row.qtyInput.value);
    if (qty < 1) return { error: 'Please enter a quantity of at least 1.' };
    var v;
    if (p.variants.length === 1) v = p.variants[0];
    else {
      var missing = row.selects.filter(function (x) { return !x.el.value; }).map(function (x) { return x.name.toLowerCase(); });
      if (missing.length) return { error: 'Please choose ' + missing.join(' and ') + '.', incomplete: true };
      var sel = selection(row);
      var exact = p.variants.filter(function (x) {
        if (x.options.length !== sel.length) return false;
        for (var i = 0; i < sel.length; i++) if (x.options[i] !== sel[i]) return false;
        return true;
      });
      if (exact.length !== 1) return { error: 'That combination is not available. Please choose different options.' };
      v = exact[0];
    }
    if (!v.available) return { error: 'Sorry, that option is sold out. Please choose another.' };
    return { variant: v, qty: qty };
  }
  function updateRowState(row) {
    var p = row.product;
    if (!p) return;
    var r = resolveRow(row);
    if (r.variant) {
      row.priceEl.textContent = money(r.variant.price) + ' each' + (r.variant.title && p.variants.length > 1 ? ' \u00b7 ' + r.variant.title : '');
    } else {
      var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
      var min = prices.length ? Math.min.apply(null, prices) : p.price;
      var max = prices.length ? Math.max.apply(null, prices) : p.price;
      row.priceEl.textContent = (min !== max ? 'From ' : '') + money(min);
    }
  }
  function showRowMsg(row, text, info) {
    row.msgEl.textContent = text;
    row.msgEl.hidden = false;
    row.msgEl.classList.toggle('ipc-qc-row__msg--info', !!info);
  }
  function hideRowMsg(row) { row.msgEl.hidden = true; row.msgEl.textContent = ''; }
  function setRowBusy(row, busy) {
    row.addBtn.disabled = busy; row.removeBtn.disabled = busy;
    row.addBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    row.addBtn.textContent = busy ? 'Adding\u2026' : 'Add to cart';
  }
  function confirmRow(row) {
    var r = resolveRow(row);
    if (r.error) {
      showRowMsg(row, r.error);
      if (r.incomplete) { var first = row.selects.filter(function (x) { return !x.el.value; })[0]; if (first) first.el.focus(); }
      return Promise.resolve(false);
    }
    hideRowMsg(row);
    setRowBusy(row, true);
    return enqueue(function () {
      return postJSON(URLS.add, { items: [{ id: r.variant.id, quantity: r.qty }] });
    }).then(function () {
      removePending(row.handle); // removes the row via syncPanel
      return true;
    }, function (err) {
      setRowBusy(row, false);
      showRowMsg(row, /sold out/i.test((err && err.message) || '') ? 'Sorry, that option just sold out. Please choose another.' : friendly(err));
      return false;
    });
  }
  function afterAdds(okCount, failCount) {
    if (!okCount) return;
    if (!readPending().length) { location.reload(); return; }
    if (panel) panel.status.textContent = okCount + (okCount === 1 ? ' item' : ' items') + ' added to your cart.' + (failCount ? ' Please check the items below.' : '');
    fetchCartRaw().then(function (c) { notifyTheme(c); renderAllCards(); }).catch(function () {});
  }
  function saveAllRows() {
    if (!panel) return;
    var rows = Object.keys(panel.rows).map(function (h) { return panel.rows[h]; });
    panel.saveAll.disabled = true;
    var ok = 0, fail = 0;
    rows.reduce(function (chain, row) {
      return chain.then(function () { return confirmRow(row).then(function (res) { if (res) ok++; else fail++; }); });
    }, Promise.resolve()).then(function () {
      if (panel) panel.saveAll.disabled = false;
      if (ok) afterAdds(ok, fail);
      else if (panel) panel.status.textContent = 'Please choose options for the items below.';
    });
  }

  /* ----------------------------------------------------- cart drawer: small note */
  function syncDrawerNote() {
    if (!CFG.drawerNote) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var items = readPending(), existing = drawer.querySelector('.ipc-qc-drawer-note');
    if (!items.length || isCartPage()) { if (existing) existing.remove(); return; }
    var host = drawer.querySelector('.cart-drawer__content') || drawer.querySelector('.cart-drawer__inner') || drawer.querySelector('dialog');
    if (!host) return;
    var n = items.length;
    var text = n + (n === 1 ? ' item needs' : ' items need') + ' a size, color, or style.';
    if (!existing || existing.parentNode !== host) {
      if (existing) existing.remove();
      existing = el('aside', { class: 'ipc-qc-drawer-note', 'data-ipc-qc': '' }, [
        el('span', { class: 'ipc-qc-drawer-note__text' }),
        el('a', { class: 'ipc-qc-btn ipc-qc-btn--primary ipc-qc-drawer-note__link', href: URLS.cart, text: 'Choose options' })
      ]);
      var heading = host.querySelector('.cart-drawer__heading');
      if (heading && heading.parentNode === host) host.insertBefore(existing, heading.nextSibling);
      else host.insertBefore(existing, host.firstChild);
    }
    var t = existing.querySelector('.ipc-qc-drawer-note__text');
    if (t.textContent !== text) t.textContent = text;
  }

  /* -------------------------------------------------------------- scanning */
  function scan() {
    $all('product-card').forEach(enhance);
    recs.forEach(function (r) { if (!r.card.isConnected) recs.delete(r); });
    if (isCartPage()) syncPanel();
    syncDrawerNote();
  }
  var scanTimer = null;
  function scheduleScan() { if (scanTimer) return; scanTimer = setTimeout(function () { scanTimer = null; scan(); }, 80); }
  function ours(node) { return node && node.nodeType === 1 && node.closest && node.closest('[data-ipc-qc], .ipc-qc-sr'); }

  function init() {
    var html = document.documentElement;
    html.classList.add('ipc-qc-ready');
    if (CFG.keepThemeQuickAdd) html.classList.add('ipc-qc-keep-qa');
    scan();
    if (recs.size || isCartPage()) refreshCart();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (ours(m.target)) continue;
        if (m.addedNodes.length || m.removedNodes.length) { scheduleScan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    var cartTimer = null;
    document.addEventListener('cart:update', function (e) {
      if (e.detail && e.detail.sourceId === SOURCE) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(refreshCart, 250);
    });
    window.addEventListener('storage', function (e) { if (e.key === CFG.storageKey) onPendingChanged(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshCart(); onPendingChanged(); } });
  }

  window.IPCQuickCards = { version: '1.0.0', config: CFG, rescan: scan, readPending: readPending,
    clearPending: function () { writePending([]); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
